import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/gallery/index.tsx");
